import { render } from "./Step4.vue?vue&type=template&id=2256279f"
import script from "./Step4.vue?vue&type=script&lang=js"
export * from "./Step4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleForm/ScalingUp/Step4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2256279f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2256279f', __exports__)) {
    api.reload('2256279f', __exports__)
  }
  
  module.hot.accept("./Step4.vue?vue&type=template&id=2256279f", () => {
    api.rerender('2256279f', render)
  })

}


export default __exports__